import { Ability, AbilityTuple, MongoQuery } from '@casl/ability'

import { Action, Subject } from '../Casl/Casl.service'

export const isStaff = (ability: Ability<AbilityTuple, MongoQuery>): boolean => ability.can(Action.Read, Subject.Admin)
export const isAdmin = (ability: Ability<AbilityTuple, MongoQuery>): boolean => ability.can(Action.Manage, Subject.All)
